import React from 'react';
import ReactDOM from 'react-dom';
import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';
import Moment from 'react-moment';
import moment from 'moment';

import {
	Col,
	BPanel,
	Radio,
	FormGroup,
	FormControl,
	ControlLabel,
	Modal,
	Button
} from '@sketchpixy/rubix';
import TimePicker from 'react-bootstrap-time-picker';

import { Places } from '../../collections/flights/places'; 

import { confirmFlight } from '../../collections/flights/methods';

export class PlanningConfirmModal extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
		this.state.showModal = false;

		if (this.props.flight) {
			Tracker.nonreactive(() => {
				this.state.subscription = Meteor.subscribe('flight', this.props.flight._id, () => {
					this.setState({
						placeId: this.props.flight.placeId || (this.places().length ? this.places()[0]._id : null),
						temp: parseInt(this.props.flight.temp) || 1,
						time: this.props.flight.period == 'morning' ? 9 : 17
					});
					this.setState({
						meetingDate: moment(this.props.flight.date).add(this.state.time, 'hours').toDate()
					});
				});
			});
		}
	}

	closeModal() {
		this.setState({ showModal: false });
	}

	openModal() {
		this.setState({ showModal: true });
	}

	confirm() {
		confirmFlight.call({
			_id: this.props.flight._id,
			temp: parseInt(this.state.temp),
			placeId: this.state.placeId,
			meetingDate: this.state.meetingDate
		}, ((err) => {
			if (err)
				return Messenger().post({
					message: err,
					type: "error"
				});

			Messenger().post({
				message: "Le vol a été validé avec succès.",
				type: "success"
			});

			this.closeModal();
		}).bind(this));
	}

	getTimeRange() {
		if (!this.props.flight)
			return { start: '0', end: '23' };

		if (this.props.flight.period == 'morning') 
			return { start: '5', end: '23' };
		else
			return { start: '5', end: '23' };
	}

	places() {
		return Places.find({}).fetch();
	}

	setMeetingDate(time) {
		this.setState({
			time,
			meetingDate: moment(this.props.flight.date).add(time, 'seconds').toDate()
		});
	}

	renderModal() {
		return (
			<Modal show={this.state.showModal} onHide={::this.closeModal}>
				<Modal.Header closeButton>
					<Modal.Title>Confirmation du vol du { moment(this.props.flight.date).format("DD/MM/YYYY") } - { this.props.flight.getPeriod() } - { this.props.flight.getPlace() }</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormGroup controlId="formControlsSelect">
						<ControlLabel>Heure de rendez-vous :</ControlLabel>
						<TimePicker start={this.getTimeRange().start} end={this.getTimeRange().end} step={15} format={24} onChange={::this.setMeetingDate} value={this.state.time}/>
					</FormGroup> 
					<FormGroup controlId="formControlsSelect">
						<ControlLabel>Température :</ControlLabel>
						<FormControl componentClass="select" placeholder="Température" onChange={(e) => this.setState({ temp: e.target.value })} defaultValue={this.state.temp}>
							<option value={1}>De 0° à 8°C</option>
							<option value={2}>De 8° à 16°C</option>
							<option value={3}>De 16° à 22°C</option>
							<option value={4}>De 22° à 28°C</option>
							<option value={5}>De 28° à 36°C</option>
							<option value={6}>36°C et +</option>
						</FormControl>
					</FormGroup>
					<FormGroup controlId="formControlsSelect">
						<ControlLabel>Lieu de rendez-vous :</ControlLabel>
						<FormControl componentClass="select" placeholder="Lieu de rendez-vous" onChange={(e) => this.setState({ placeId: e.target.value })} defaultValue={this.state.placeId}>
							{this.places().map((place) => {
								return (
									<option value={place._id}>{place.name}</option>
								);
							})}
						</FormControl>
					</FormGroup>
				</Modal.Body>
				<Modal.Footer>
					<Button bsStyle="success" onClick={::this.confirm}>Valider</Button>
				</Modal.Footer>
			</Modal>
		);

	}

	render() {
		return (
			<div>
				<Button bsStyle="success" onClick={::this.openModal}>Valider mon vol</Button>
				{this.state.showModal && this.renderModal()}
			</div>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningConfirmModal.js
 **/